module.exports = __webpack_public_path__ + "img/22cc34d8a0eebb8e52f40e99295dc950.png";